import { theme } from "@project/shared/src/theme";
import { styled } from "linaria/lib/react";
import Link from "next/link";
import { AboutLPType } from "../../organism/AboutLP";
const Card = /*#__PURE__*/styled("article")({
  name: "Card",
  class: "c1vj8nw2"
});

const AboutLPCard = ({
  title,
  image,
  url
}: AboutLPType) => {
  return <Link href={url}>
      <a target="_blank">
        <Card>
          <img src={image} height={207} alt={title} />
          <div className="content">
            <h4>{title}</h4>
          </div>
        </Card>
      </a>
    </Link>;
};

export { AboutLPCard };

require("./index.linaria.module.css!=!../../../../../node_modules/linaria/lib/outputCssLoader.js?cacheProvider=!./index.tsx");